import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RequestService } from '@app/core/request/request.service';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class AdresAfbeeldingService {
    constructor(private request: RequestService) {}

    opvragenAfbeelding(max_width: number, max_height: number, adres: any): Observable<any> {
        const url = 'adres-algemeen/opvragen/afbeelding-adres';

        const payload = {
            max_width: max_width,
            max_height: max_height,
            adres: adres,
        };

        return this.request.post(url, payload).pipe(map((resultaat) => resultaat.data));
    }
}
